import React from 'react';
import type { IconProps } from '../types/icons';

export default function ChevronRight({
  width = 20,
  height = 20,
  fill = '#6F757E',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <g id="chevron-right" transform={`scale(${width / 20},${height / 20})`}>
        <path
          id="Vector"
          d="M7.1499 6.175L10.9749 10L7.1499 13.825L8.33324 15L13.3332 10L8.33324 5L7.1499 6.175Z"
          fill={fill}
        />
      </g>
    </svg>
  );
}
